// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary[data-v-57237186]{color:#c81919}.container[data-v-57237186]{padding-top:0}.my--coin-usage[data-v-57237186]{border:solid 1px #ccc;border-radius:16px;padding:24px 24px}@media only screen and (max-width: 768px){.my--coin-usage[data-v-57237186]{border:none;padding:24px 0}}.my--coin-usage .v-data-table thead tr[data-v-57237186]{background-color:#c81919}.my--coin-usage .v-data-table thead tr th[data-v-57237186]{color:#fff !important}", ""]);
// Exports
module.exports = exports;
